import axios from 'axios';
import {BaseResponse} from "../BaseResponse";

export async function deleteVihecle(vihecleId : string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/vihecle/${vihecleId}`)

    return response.data
}

